<template>
  <v-container
    fluid
    class="view-wizard">
    <div
      class="corporate-color-bar" />
    <v-stepper
      v-model="currentStep"
      :continuous="false"
      ref="window"
      lazy>
      <v-stepper-items>

        <WizardPageHello
          :step="1"
          :current-step="currentStep" />

        <WizardPageDSB
          :step="2"
          :current-step="currentStep" />

        <WizardPageQuestion
          v-for="(page, index) in pages"
          :index="index"
          :key="page.key"
          :page="page"
          :answers="answers"
          :step="3 + index"
          :current-step="currentStep"
          :num-pages="pages.length" />

          <WizardPageGoodBye
            :step="3 + pages.length"
            :current-step="currentStep" />
      </v-stepper-items>

    </v-stepper>
  </v-container>
</template>

<script>
import WizardPageDSB from './components/WizardPageDSB'
import WizardPageHello from './components/WizardPageHello'
import WizardPageGoodBye from './components/WizardPageGoodBye'
import WizardPageQuestion from './components/WizardPageQuestion'
import BL from '@/bl/bl'

export default {
  name: 'Wizard',

  components: {
    WizardPageDSB,
    WizardPageQuestion,
    WizardPageHello,
    WizardPageGoodBye
  },

  beforeRouteLeave (to, from, next) {
    if (this.currentStep > 1) {
      next(false)
      this.currentStep--
    } else {
      next()
    }
  },

  mounted () {
    window.$wizard = this
    this.$store.commit('generateCandidateUUID')
  },

  data: () => ({
    currentStep: 1,
    answers: []
  }),

  watch: {
    currentStep () {
      // Yeah. This app needs to be able to run in an iframe. Mobile Safari tends to not behave like cool browsers
      // and does not reset the documents scroll position when a page changes. Yet, it does render content like it did reset.
      // We need to reset manually.
      window.scrollTo(0, 0)
    }
  },

  computed: {
    pages () {
      const pages = BL.getPagesToRender(this.answers)
      return pages
    }
  },

  methods: {
    onNext (windowItemInstance) {
      if (windowItemInstance && windowItemInstance.page && windowItemInstance.page === this.pages[this.pages.length - 1]) {
        BL.createCandidateAndSaveWithAnswers(this.answers)
      }

      this.currentStep += 1
    },

    onBack (windowItemInstance) {
      this.currentStep += this.currentStep > 1 ? -1 : 1
    }
  }
}
</script>

<style lang="scss">
  .view-wizard {
    .corporate-color-bar {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
    > .v-stepper {
      box-shadow: none !important;

      .v-stepper__content {
        padding: 0;

        .v-card {
          max-width: 640px;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }
</style>
